export default "__VITE_ASSET__Dicb2_q6__"